import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMediaKey } from '../../utils/keys';
export const useMedia = (options) => {
    const { variables, fields = 'basic', useQueryOptions } = options;
    const { client } = useTribeClient();
    const exportRequestKey = getMediaKey({ variables, fields });
    return useQuery(exportRequestKey, () => client.query({
        name: 'media',
        args: {
            fields,
            variables,
        },
    }), useQueryOptions);
};
//# sourceMappingURL=useMedia.js.map